import api from "./api";

const route = "/files";

// Direct-to-S3 multipart upload tuning.
const PART_SIZE = 32 * 1024 * 1024; // 32 MB per part
const CONCURRENCY = 4; // parallel part uploads (recovers bandwidth like speedtest)

const AdjuntosService = {
  getAdjunto: () => api.get(route),
  postAdjunto: (formData) =>
    api.post(route, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  // Uploads a File straight to S3 in parallel parts, going through our API only
  // to open/sign/complete the multipart upload. Returns the same shape as
  // postAdjunto's response data: { file_id, file: { file_id, name, type } }.
  // onProgress (optional) receives an integer 0..100.
  uploadFileMultipart: async (file, onProgress) => {
    const { data: start } = await api.post(`${route}/multipart/start`, {
      filename: file.name,
      contentType: file.type,
    });
    const { file_id, key, uploadId } = start;

    const total = Math.ceil(file.size / PART_SIZE);
    const parts = new Array(total);
    const queue = [...Array(total).keys()];
    let uploadedBytes = 0;

    const worker = async () => {
      let i;
      while ((i = queue.shift()) !== undefined) {
        const partNumber = i + 1;
        const blob = file.slice(
          i * PART_SIZE,
          Math.min(file.size, (i + 1) * PART_SIZE)
        );
        const { data: signed } = await api.post(`${route}/multipart/sign`, {
          key,
          uploadId,
          partNumber,
        });
        // Bare PUT to the presigned URL — no auth header, no extra headers.
        const put = await fetch(signed.url, { method: "PUT", body: blob });
        if (!put.ok) {
          throw new Error(`Falló la subida de una parte del video (${partNumber}).`);
        }
        const etag = put.headers.get("ETag") || put.headers.get("etag");
        if (!etag) {
          throw new Error(
            "No se pudo leer el ETag de S3. Revisa la configuración CORS del bucket."
          );
        }
        parts[i] = { PartNumber: partNumber, ETag: etag };
        uploadedBytes += blob.size;
        if (onProgress) {
          onProgress(Math.round((uploadedBytes / file.size) * 100));
        }
      }
    };

    try {
      await Promise.all(
        Array.from({ length: Math.min(CONCURRENCY, total) }, worker)
      );
      const { data } = await api.post(`${route}/multipart/complete`, {
        file_id,
        key,
        uploadId,
        parts,
      });
      return data;
    } catch (error) {
      // Best-effort cleanup so abandoned parts don't linger in S3.
      api.post(`${route}/multipart/abort`, { key, uploadId }).catch(() => {});
      throw error;
    }
  },
};

export default AdjuntosService;
